<div [ngClass]="_tableClasses">
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container
      *ngFor="let columnDef of columnDefinitions"
      [matColumnDef]="columnDef.columnName"
    >
      <th
        mat-header-cell
        mat-sort-header
        [disabled]="true"
        *matHeaderCellDef
        [style.width]="columnDef.columnWidth"
        [style.text-align]="columnDef.columnTextAlign"
      >
        {{ columnDef.header | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let element; let i = index"
        [style.width]="columnDef.columnWidth"
        [style.text-align]="columnDef.columnTextAlign"
        [style.text-overflow]="'ellipsis'"
      >
        <span
          class="table-cell column-text"
          *ngIf="columnDef.columnType == 'string'"
          [matTooltip]="element[columnDef.columnName]"
          [style.width]="columnDef.columnWidth"
          >{{ element[columnDef.columnName] }}</span
        >

        <span
          class="table-cell column-truncated"
          *ngIf="columnDef.columnType == 'truncated-string'"
          [matTooltip]="element[columnDef.columnName]"
          [style.width]="columnDef.columnWidth"
          >{{ element[columnDef.columnName] }}</span
        >

        <span
          class="table-cell"
          *ngIf="columnDef.columnType == 'icon'"
          [matTooltip]="element[columnDef.columnName]"
          [style.transform]="
            'rotate(' + element[columnDef.columnName].rotation + 'deg)'
          "
          [style.color]="element[columnDef.columnName].color"
          class="column-text material-symbols-outlined"
          >{{ element[columnDef.columnName].icon }}</span
        >

        <app-reddi-response-icon
          class="table-cell"
          *ngIf="columnDef.columnType == 'reddi-response-icon'"
          [matTooltip]="element[columnDef.columnName].tooltip"
          [type]="element[columnDef.columnName].type"
          [outcome]="element[columnDef.columnName].outcome"
          [size]="20"
        />

        <app-category-tile
          *ngIf="columnDef.columnType == 'category'"
          [matTooltip]="element[columnDef.columnName]"
          [color]="element[columnDef.columnName].linkColor"
          >{{ element[columnDef.columnName].linkText }}</app-category-tile
        >

        <app-link
          *ngIf="columnDef.columnType == 'link'"
          [color]="columnDef.linkColor"
          [destination]="element[columnDef.columnName].linkUrl"
          [matTooltip]="element[columnDef.columnName].linkText | translate"
          [showIcon]="columnDef.showIcon"
          [kind]="columnDef.linkKind"
          [width]="columnDef.columnWidth"
          (click)="
            onLinkClick.emit([
              columnDef.columnName,
              element[columnDef.columnName].linkData
            ])
          "
          >{{ element[columnDef.columnName].linkText | translate }}</app-link
        >

        <app-link-button
          *ngIf="
            columnDef.columnType == 'link-button' &&
            element[columnDef.columnName]
          "
          [color]="columnDef.linkButtonColor"
          [type]="columnDef.linkButtonType"
          [ariaLabel]="element[columnDef.columnName].ariaLabel"
          (click)="
            onLinkButtonClick.emit([
              columnDef.columnName,
              element[columnDef.columnName].linkData
            ])
          "
          >{{ element[columnDef.columnName].linkText }}</app-link-button
        >

        <app-quick-view-button
          *ngIf="columnDef.columnType == 'quick-view-button'"
          [selected]="element[columnDef.columnName].selected"
          (click)="
            onQuickViewClicked([
              columnDef.columnName,
              element[columnDef.columnName].linkData
            ])
          "
          [fieldName]="columnDef.columnName"
          [data]="element[columnDef.columnName].linkData"
          [color]="columnDef.linkButtonColor"
        >
          {{ element[columnDef.columnName].linkText }}</app-quick-view-button
        >
        <app-reddi-round-edit-button
          class="table-cell"
          *ngIf="columnDef.columnType == 'reddi-round-edit-button'"
          [rowIndex]="i"
          (editClick)="onEditClick.emit({ element: element, index: i })"
        />
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr
      mat-row
      *matRowDef="let row; let i = index; columns: columnsToDisplay"
      [matTooltip]="row.tooltipText"
    ></tr>
    <tr class="mat-row" *matNoDataRow>
      <td
        class="mat-cell table-no-data"
        [attr.colspan]="columnsToDisplay.length"
      >
        {{ noDataText }}
      </td>
    </tr>
  </table>
  <mat-paginator
    *ngIf="showPager"
    appButtonPagination
    aria-label="Select page"
    [appCustomLength]="dataSource.data.length"
    [length]="dataSource.data.length"
    [pageSize]="12"
  >
  </mat-paginator>
</div>
